var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.825 34.6119C28.6599 34.6119 28.4948 34.5638 28.3512 34.4669L19.5001 28.4752L10.6491 34.4669C10.3546 34.6665 9.96655 34.66 9.6786 34.4507C9.39065 34.2414 9.26455 33.8748 9.36335 33.5329L12.3267 23.2635L3.89295 16.6972C3.61215 16.4788 3.4984 16.1077 3.60825 15.7697C3.7181 15.431 4.02815 15.1983 4.3837 15.186L15.0665 14.8311L18.7052 4.78142C18.8261 4.44667 19.1439 4.22437 19.4995 4.22437C19.855 4.22437 20.1728 4.44732 20.2937 4.78142L23.9325 14.8311L34.6152 15.186C34.9708 15.1977 35.2808 15.431 35.3906 15.7697C35.5005 16.1083 35.3868 16.4788 35.106 16.6972L26.6722 23.2635L29.6355 33.5329C29.7344 33.8748 29.6082 34.2414 29.3203 34.4507C29.1721 34.5579 28.9979 34.6119 28.8237 34.6119H28.825ZM19.5001 26.6091C19.6652 26.6091 19.831 26.6578 19.974 26.754L27.3658 31.7584L24.8906 23.1816C24.795 22.8495 24.9107 22.4926 25.1831 22.2807L32.2265 16.7973L23.3052 16.5009C22.9601 16.4892 22.6565 16.2689 22.5389 15.9439L19.5001 7.55042L16.4614 15.9439C16.3437 16.2689 16.0402 16.4892 15.695 16.5009L6.77375 16.7973L13.8172 22.2807C14.0895 22.4933 14.2059 22.8495 14.1097 23.1816L11.6345 31.7584L19.0263 26.754C19.1693 26.6572 19.3344 26.6091 19.5001 26.6091Z",
    fill: "#F29550"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/Star.4d1bdac11a5bf9abee011c94e8a058de.svg";
export { ForwardRef as ReactComponent };